<template>
<div class="wrapper">
<div class="row row-wider">
<div class="col-md-12" style="min-height: 150px;">
<tabs nav-style="tabs" v-model="activeTabIndex">
    <tab header="QA/QC Recording">
        <loader v-if="culturalResourceRecordingLoading"/>
        <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form" id="sticky">
          <div class="container">
            <div class="sticky" v-if="!isSegment">
              <ul>
                <li><a href="#overviewQaqc">Overview</a></li>
                <li><a href="#locationQaqc">Location</a></li>
                <li><a href="#nationalRegisterStatusQaqc">Register Status</a></li>
                <li><a href="#investigativeHistoryQaqc">Investigative History</a></li>
                <li><a href="#propertyDescriptionQaqc">Property Description</a></li>
                <li><a href="#siteSettingQaqc">Site Setting</a></li>
              </ul>
            </div>
            <div class="panel panel-offset" id="overviewQaqc">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">Overview</h3>
                </div>
                <div class="panel-body">
                    <identificationForm ref="identificationForm" :style="identificationStyle" :culturalResourceRecording="culturalResourceRecording" :culturalResource="culturalResource"
                    :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :saveQaqcProgress="saveQaqcProgress" source='CulturalResourceRecording' ></identificationForm>
                </div>
            </div>

            <div class="panel panel-offset" id="locationQaqc"  v-if="!isSegment">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">Location</h3>
                </div>
                <div class="panel-body">
                    <locationForm ref="locationForm" :style="locationStyle" :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                    :saveQaqcProgress="saveQaqcProgress" :crrId="qaqcCrrId"></locationForm>
                </div>
            </div>

            <div class="panel panel-offset" v-bind:style="nationalRegisterStatusStyle" id="nationalRegisterStatusQaqc"  v-if="!isSegment">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">National Register Status</h3>
                </div>
                <div class="panel-body">
                    <nationalRegisterStatusForm :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                    :saveQaqcProgress="saveQaqcProgress" :crrId="qaqcCrrId"></nationalRegisterStatusForm>
                </div>
            </div>

            <div class="panel panel-offset" v-bind:style="investigativeHistoryStyle" name="inventoryHistoryPanel" id="investigativeHistoryQaqc" v-if="!isSegment">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">Investigative History</h3>
                </div>
                <div class="panel-body">
                    <investigativeHistoryForm :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                    :saveQaqcProgress="saveQaqcProgress" :crrId="qaqcCrrId"></investigativeHistoryForm>
                </div>
            </div>

            <div class="panel panel-offset" v-bind:style="propertyDescriptionStyle" id="propertyDescriptionQaqc" v-if="!isSegment">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">Property Description</h3>
                </div>
                <div class="panel-body">
                    <propertyDescriptionForm :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                    :saveQaqcProgress="saveQaqcProgress" :crrId="qaqcCrrId"></propertyDescriptionForm>
                </div>
            </div>

            <div class="panel panel-offset" v-bind:style="siteSettingStyle" name="siteSettingPanel" id="siteSettingQaqc" v-if="!isSegment">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">Site Setting</h3>
                </div>
                <div class="panel-body">
                    <siteSettingForm :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                    :saveQaqcProgress="saveQaqcProgress" :crrId="qaqcCrrId"></siteSettingForm>
                </div>
            </div>
          </div>
        </form>
    </tab>
    <tab v-if="culturalResource.siteTypeId !== propertyTypeEnum.Building" header="QA/QC Site Narrative">
        <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form">
            <div class="panel panel-offset" id="siteNarrative">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">SITE NARRATIVE</h3>
                </div>
                <div class="panel-body">
                    <div class="form-group">
                        <label class="col-md-2 control-label">DESCRIPTION</label>
                        <div class="col-md-10">
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteNarrative'" :hasAppend="true"></qaqcFormFieldSelect>
                            <!-- <textarea class="form-control" rows="15" v-model="culturalResourceRecording.siteNarrative"/> -->
                            <editor id="editorSiteNarrativeQaqc" v-model="culturalResourceRecording.siteNarrative" :init="editor.options"></editor>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary pull-right" v-on:click="saveSiteNarrative">Save</button>
                        </div>
                    </div>
                    <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'siteNarrativeBuildingDescHistory'" :completeSection="completeSection"></qaqcFormFieldFooter>
                </div>
            </div>
        </form>
    </tab>
    <tab v-if="culturalResource.siteTypeId == propertyTypeEnum.Building" header="QA/QC Property Desc./History">
        <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form">
            <div class="panel panel-offset" id="siteNarrative">
                <div class="panel-heading qaqc-bg">
                    <h3 class="panel-title">PROPERTY DESCRIPTION/HISTORY</h3>
                </div>
                <div class="panel-body">
                    <div class="form-group">
                        <label class="col-md-2 control-label">PROPERTY DESCRIPTION</label>
                        <div class="col-md-10">
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'buildingDescription'" :hasAppend="true"></qaqcFormFieldSelect>
                            <!-- <textarea class="form-control" rows="10" v-model="culturalResourceRecording.buildingDescription"/> -->
                            <editor id="editorBuildingDescQaqc" v-model="culturalResourceRecording.buildingDescription" :init="editor.options"></editor>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">PROPERTY HISTORY</label>
                        <div class="col-md-10">
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'buildingHistory'" :hasAppend="true"></qaqcFormFieldSelect>
                            <!-- <textarea class="form-control" rows="10" v-model="culturalResourceRecording.buildingHistory"/> -->
                            <editor id="editorBuildingHistQaqc" v-model="culturalResourceRecording.buildingHistory" :init="editor.options"></editor>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary pull-right" v-on:click="saveSiteNarrative">Save</button>
                        </div>
                    </div>
                    <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'siteNarrativeBuildingDescHistory'" :completeSection="completeSection"></qaqcFormFieldFooter>
                </div>
            </div>
        </form>
    </tab>
    <tab header="Shape File Append">
        <qaqcShapeFileAppend :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
        :saveQaqcProgress="saveQaqcProgress"></qaqcShapeFileAppend>
    </tab>
    <tab :disabled="false" header="QA/QC Attachments">
        <attachments ref="attachments" :qaqcEnabled="qaqcEnabled" :productionCrrId="productionCrrId" :qaqcProgressDto="qaqcProgressDto"
        :saveQaqcProgress="saveQaqcProgress" :crrId="qaqcCrrId" :loadOnMount="false"></attachments>
    </tab>
    <tab v-if="qaqcEnabled" header="QA/QC Progress">
        <qaqcProgress ref="qaqcProgress" :qaqcProgressDto="qaqcProgressDto" :isSegment="isSegment"></qaqcProgress>
    </tab>
</tabs>
</div>
</div>
<div v-if="isDebug">
    <div>
        <h3 class="text-danger">****** Debug ******</h3>
    </div>
    <div>
    </div>
</div>
</div>
</template>

<script>

import loggingService from '../services/util/loggingService'
//import culturalResourceService from '../services/culturalResourceService'
import culturalResourceRecordingService from '../services/culturalResourceRecordingService'
import qaqcService from '../services/qaqcService'
import loader from '../components/Loader.vue'
import identificationForm from '../components/SiteForm/IdentificationForm.vue'
import locationForm from '../components/SiteForm/LocationForm.vue'
import nationalRegisterStatusForm from '../components/SiteForm/NationalRegisterStatusForm.vue'
import investigativeHistoryForm from '../components/SiteForm/InvestigativeHistoryForm.vue'
import propertyDescriptionForm from '../components/SiteForm/PropertyDescriptionForm.vue'
import siteSettingForm from '../components/SiteForm/SiteSettingForm.vue'
import attachments from '../components/SiteForm/Attachments.vue'
import qaqcProgress from '../components/SiteForm/QaqcProgress.vue'
import qaqcFormFieldSelect from '../components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'
import qaqcShapeFileAppend from '@/components/SiteForm/QaqcShapeFileAppend.vue'
import mapx from '@/views/MapNew'

import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'
import editor from '@tinymce/tinymce-vue'
import { tab, tabs } from 'vue-strap'

export default {
    components: {
        tabs,
        tab,
        identificationForm,
        nationalRegisterStatusForm,
        investigativeHistoryForm,
        propertyDescriptionForm,
        siteSettingForm,
        loader,
        locationForm,
        attachments,
        mapx,
        qaqcProgress,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter,
        qaqcShapeFileAppend,
        editor
    },
    props: {
        culturalResource: {},
        loadOnMount: { default: true }
    },
    computed: {
        isConditionReport: function () {
            return this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.ConditionReport
        },
        isSiteLead: function () {
            return this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.SiteLead
        },
        identificationStyle: function () {
            return {}
        },
        locationStyle: function () {
            return {}
        },
        nationalRegisterStatusStyle: function () {
            return {}
        },
        investigativeHistoryStyle: function () {
            return {}
        },
        propertyDescriptionStyle: function () {
            return {}
        },
        siteSettingStyle: function () {
            return {}
        },
        propertyTypeEnum: function () {
            return culturalResourceRecordingService.PropertyTypeEnum
        },
        isDistrictMember: function () {
            return (this.culturalResource.grouping === 'Group Member' && !(this.culturalResource.segment))
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        // disable forms if user is not consultant
        formDisabled: function () {
            return !(userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser, roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator]))
        },
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no propertyDescription qa/qc object, create new instance
                if (!this.qaqcProgressDto.qaqcSelections.siteNarrativeBuildingDescHistory) {
                    this.qaqcProgressDto.qaqcSelections.siteNarrativeBuildingDescHistory = qaqcService.qaqcSelections().siteNarrativeBuildingDescHistory
                }
                return this.qaqcProgressDto.qaqcSelections.siteNarrativeBuildingDescHistory
            } else {
                return {}
            }
        },
        isSegment: function () {
            return this.culturalResource && this.culturalResource.segment > 0
        }
    },
    data: function () {
        return {
            isDebug: false,
            activeTabIndex: 0,
            culturalResourceRecordingLoading: true,
            culturalResourceRecordingId: this.$route.params.culturalResourceRecordingId,
            qaqcCrrId: null,
            disabledStyle: {
                'pointer-type': 'None',
                'opacity': 0.4
            },
            culturalResourceRecording: {},
            qaqcEnabled: true,
            qaqcProgressDto: {},
            productionCrr: {},
            productionCrrId: null,
            tabsEnum: {
                recording: 0,
                narrative: 1,
                shapeFile: 2,
                attachments: 3,
                attachmentsLoaded: false,
                progress: 4
            },
            recordingTypeEnum: culturalResourceRecordingService.RecordingTypeEnum,
            editor: {
                options: {
                    selector: '#editor',
                    height: 500,
                    plugins: 'lists paste table',
                    oninit: 'setPlainText',
                    forced_root_block: false,
                    browser_spellcheck: true,
                    menubar: 'edit format',
                    toolbar: 'undo redo | fontselect fontsizeselect | bullist table',
                    table_default_attributes: {
                        border: '1',
                        width: '50%',
                        cellspacing: '0'
                    },
                    paste_postprocess: (plugin, args) => {
                        args.node.querySelectorAll('table').forEach(tableNode => {
                            tableNode.setAttribute('border', '1')
                            tableNode.setAttribute('cellspacing', '0')
                        })
                    },
                    content_style: 'body { font-family: Arial; }',
                    remove_linebreaks: false
                }
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'QA/QC', 'mounted')
        if (this.loadOnMount) this.loadQaqcData()
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'QA/QC', 'watch.activeTabIndex: ' + val)
            switch (val) {
            case this.tabsEnum.recording:
                break
            case this.tabsEnum.narrative:
                break
            case this.tabsEnum.shapeFile:
                break
            case this.tabsEnum.attachments:
                if (!this.tabsEnum.attachmentsLoaded) this.$refs.attachments.loadData()
                this.tabsEnum.attachmentsLoaded = true
                break
            case this.tabsEnum.progress:
                break
            }
        }
    },
    methods: {
        loadQaqcData () {
            this.culturalResourceRecordingLoading = true
            loggingService.log(this.isDebug, 'CRR - QA/QC', 'loadQaqcData for CRR Id' + this.culturalResourceRecordingId)
            culturalResourceRecordingService.getQaqcRecord(this.$http, this.culturalResourceRecordingId, false, true).then(response => {
                this.culturalResourceRecording = response.data
                if (this.culturalResourceRecording.siteNarrative) {
                    this.culturalResourceRecording.siteNarrative = this.culturalResourceRecording.siteNarrative.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.culturalResourceRecording.buildingDescription) {
                    this.culturalResourceRecording.buildingDescription = this.culturalResourceRecording.buildingDescription.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.culturalResourceRecording.buildingHistory) {
                    this.culturalResourceRecording.buildingHistory = this.culturalResourceRecording.buildingHistory.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                this.qaqcCrrId = this.culturalResourceRecording.culturalResourceRecordingId
                this.loadQaqcProgress()
                this.loadProduction()
                this.culturalResourceRecordingLoading = false
            })
        },
        loadQaqcProgress () {
            loggingService.log(this.isDebug, 'CRR - QA/QC', 'load QAQC Progress for CRR Id ' + this.culturalResourceRecordingId)
            culturalResourceRecordingService.getQaqcProgress(this.$http, this.culturalResourceRecordingId).then(response => {
                this.qaqcProgressDto = response.data
                // qaqcSelections object
                if (this.qaqcProgressDto.qaqcSelections) {
                    // parse the stored JSON string into JSON object
                    this.qaqcProgressDto.qaqcSelections = JSON.parse(this.qaqcProgressDto.qaqcSelections)
                } else {
                    // create new qaqcSelections object
                    this.qaqcProgressDto.qaqcSelections = qaqcService.qaqcSelections()

                    var attachmentSelection = this.culturalResourceRecording.attachmentSelection
                    // create rockArt selections
                    if (attachmentSelection.hasRockArt) {
                        for (let i = 0; i < attachmentSelection.rockArtCount; i++) { this.qaqcProgressDto.qaqcSelections.rockArt.push(qaqcService.rockArtSelection()) }
                    }
                    // create historicBuilding selections
                    if (attachmentSelection.hasHistoricBuilding) {
                        for (let i = 0; i < attachmentSelection.historicBuildingCount; i++) { this.qaqcProgressDto.qaqcSelections.historicBuilding.push(qaqcService.historicBuildingSelection()) }
                    }
                    // create structureObject selections
                    if (attachmentSelection.hasStructureObject) {
                        for (let i = 0; i < attachmentSelection.structureObjectCount; i++) { this.qaqcProgressDto.qaqcSelections.structureObject.push(qaqcService.structureObjectSelection()) }
                    }
                }
            })
        },
        loadProduction () {
            loggingService.log(this.isDebug, 'CRR - QA/QC', 'load Production CRR for CR Id' + this.culturalResourceRecording.culturalResourceId)
            this.productionCrr = {}
            culturalResourceRecordingService.getProduction(this.$http, this.culturalResourceRecording.culturalResourceId, false).then(response => {
                if (response.data) {
                    loggingService.log(this.isDebug, 'CRR - QA/QC', 'Production CRR found for CR Id' + this.culturalResourceRecording.culturalResourceId)
                    this.productionCrr = response.data
                    this.productionCrrId = this.productionCrr.culturalResourceRecordingId
                } else {
                    loggingService.log(this.isDebug, 'CRR - QA/QC', 'No Production Data found CR Id' + this.culturalResourceRecording.culturalResourceId)
                    //TODO:  how to handle if no production record found, do we create new production record here?
                    this.productionCrrId = 0
                }
            })
        },
        saveSiteNarrative () {
            culturalResourceRecordingService.put(this.$http, this.culturalResourceRecording)
        },
        submit () {
            //Nothing to do
        },
        //method to update QA/QC progress and selection.  This is passed to child component forms
        saveQaqcProgress (sectionName, markComplete) {
            loggingService.log(this.isDebug, 'Cultural Resource Recording', `updating and saving QAQC Progress for ${sectionName}`)
            // update qaqc Progress
            // this.qaqcProgressDto[sectionName] = !this.qaqcProgressDto[sectionName]
            this.qaqcProgressDto[sectionName] = markComplete

            // create a new copy of the qaqcProgressDto (assign by value), so we can JSON.stringify the qaqcSelections without affecting the original object
            var qaqcProgressSave = Object.assign({}, this.qaqcProgressDto)
            // stringify the qaqcSelections
            qaqcProgressSave.qaqcSelections = JSON.stringify(qaqcProgressSave.qaqcSelections)
            culturalResourceRecordingService.putQaqcProgress(this.$http, qaqcProgressSave)
        },
        completeSection (sectionName) {
            // check if site is a building, then check the appropriate select fields
            var valid = true
            if (this.culturalResource.siteTypeId !== this.propertyTypeEnum.Building) {
                if (this.qaqcSelection.siteNarrative === 0) { valid = false }
            } else {
                if (this.qaqcSelection.buildingDescription === 0 || this.qaqcSelection.buildingHistory === 0) { valid = false }
            }
            if (!valid) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveSiteNarrative()
            this.saveQaqcProgress('siteNarrativeBuildingDescHistory', true)
        }
    }
}

</script>

<style>
/* TODO: figure out where to override panel-heading in css file */
.qaqc-bg {
    background: #7a2134 !important;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 55px;
  z-index: 1000;
  height: 50px;
  background-color: rgb(194, 194, 178);
  padding: 0 10px;
  color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.sticky ul {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-left: 0;
  height: inherit;
}

.sticky li {
  list-style: none;
  height: 100%;
  line-height: 50px;
}

.sticky li a {
  display: block;
  text-decoration: none;
  color: #263c46;
  height: 100%;
  width: 100%;
  padding: 0 5px;
}

.sticky li a:hover {
  background-color: rgb(194, 194, 178);
  filter: brightness(85%);
}

#overview {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// QaqcCulturalResourceRecording.vue?4dceed61